<template>
  <div>
    <div class='h-track-nopadding' :class='checkBoxClassObject' v-for='(option, index) in data.datasource' :key='index'>
      <ejs-checkbox
        :value='option.value'
        :label='option.showName'
        :name='option.name'
        :checked='option.checked'
        :id='option.realName'
        :disabled='option.disabled'
        @change="checkChange"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormCheckBox',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    opCode: {
      type: String,
      default: ''
    },
    formParam: {
      type: Object,
      default() {
        return {
          name: ''
        };
      }
    },
    defaultData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    checkBoxClassObject() {
      switch (Number(this.data.colShowSize)) {
        case 1: return 'col-sm-12';
        case 2: return 'col-sm-6';
        case 3: return 'col-sm-4';
        case 4: return 'col-sm-3';
        case 6: return 'col-sm-2';
        case 12: return 'col-sm-1';
        default: return 'col-sm-6';
      }
    }
  },
  created() {
    this.data.value = new Map();
  },
  mounted() {
    const data = JSON.stringify(this.defaultData) !== '{}' ? JSON.parse(this.defaultData.paramsJson) : '';
    for (let i = 0; i < this.data.datasource.length; i++) {
      if (data[this.data.datasource[i].realName]) {
        this.data.datasource[i].checked = true;
        if (this.opCode != 'detail') {
          this.switchStyle(this.data.datasource[i].realName,this.data.datasource[i].value,true, false)
        }
      }
      this.data.datasource[i].disabled = this.opCode === 'detail' ? true : this.data.datasource[i].disabled;
    }
    if (this.opCode === 'detail') {
      this.data.datasource = this.data.datasource.concat();
    }
  },
  methods: {
    checkChange(event) {
      this.switchStyle(event.event.target.id,event.event.target.value,event.checked, true);
    },
    switchStyle(realName, value, flag, validateFlag) {
      const $this = this;
      if (this.data.changeName) {
        const map = new Map(this.data.changeName);
        const nameArr = map.get(realName);
        nameArr.forEach(item => {
          const obj = document.getElementsByName(item)[0];
          const paramObj = $this.formParam.param[$this.formParam.param.findIndex(v => v.name === item)];
          if (obj.type == 'textarea' || obj.type == 'text') {
            paramObj.enabled = !flag;
            //obj.disabled = flag;
            //obj.ej2_instances[0].enabled = !flag;
            if (flag) {
              //obj.placeholder = '';
              //obj.value = '';
              paramObj.oldPlaceholder = paramObj.placeholder;
              paramObj.placeholder = '';
              paramObj.value = '';
            } else {
              //obj.placeholder = paramObj.placeholder;
              paramObj.placeholder = paramObj.oldPlaceholder;
            }
          } else {//checkbox
            //obj.disabled = flag;
            paramObj.disabled = !flag;
          }
          if (flag && document.getElementById(item+'-info')) {
            document.getElementById(item+'-info').setAttribute('style', 'display: none');
          }
        });
        if (validateFlag) {
          this.$emit('validateUpdate', nameArr, flag ? "remove" : "add");
        }
      }
      if (flag) {
        // $this.data.value.clear();
        $this.data.value.set(realName, value);
        console.log("map", $this.data.value);
      } else {
        $this.data.value.delete(realName);
      }
    }
  }
};
</script>
